import { render, staticRenderFns } from "./WbTool.vue?vue&type=template&id=e606cf96&scoped=true&"
import script from "./WbTool.vue?vue&type=script&lang=js&"
export * from "./WbTool.vue?vue&type=script&lang=js&"
import style0 from "./WbTool.vue?vue&type=style&index=0&id=e606cf96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e606cf96",
  null
  
)

export default component.exports